import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AdministrativeUnit } from "../models/organizations/administrative-unit";
import { School } from "../models/organizations/school";

@Injectable({
  providedIn: "root",
})
export class PublicAgencyService {
  private baseUrl = "api/public/agency";

  constructor(private http: HttpClient) {}

  getAdministrativeUnitsByCurrentSchoolYear() {
    return this.http.get<AdministrativeUnit[]>(
      `${this.baseUrl}/administrativeUnits`
    );
  }

  getSchoolsByCurrentSchoolYearAndAu(administrativeUnitId: string) {
    return this.http.get<School[]>(
      `${this.baseUrl}/schools/${administrativeUnitId}`
    );
  }

  searchSchoolsByName(searchTerm: string) {
    return this.http.get<School[]>(
      `${this.baseUrl}/schools/search?searchTerm=${encodeURIComponent(searchTerm)}`
    );
  }
}
